"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var VerticalCarousel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(VerticalCarousel, _React$Component);
  var _super = (0, _createSuper2.default)(VerticalCarousel);
  function VerticalCarousel(props) {
    var _this;
    (0, _classCallCheck2.default)(this, VerticalCarousel);
    _this = _super.call(this, props);
    _this.rotateCarousel = _this.rotateCarousel.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      rotationCount: 0
    };
    return _this;
  }
  (0, _createClass2.default)(VerticalCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.intervalId = setInterval(this.rotateCarousel, this.props.cycleRate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: "rotateCarousel",
    value: function rotateCarousel() {
      this.setState({
        // eslint-disable-next-line react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
        rotationCount: this.state.rotationCount + 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var numberInRotation = 3; // Showing only 3 values in carousel makes rotation effect more dramatic
      var rotationDistribution = 360 / numberInRotation;
      var radius = Math.round(this.props.height / 2 / Math.tan(Math.PI / numberInRotation));
      var figureTranslation = "".concat(radius, "px");
      var carouselRotation = this.state.rotationCount * rotationDistribution;
      var carouselTransformStyle = "translateZ(".concat(radius * -1, "px) rotateX(").concat(carouselRotation, "deg)");
      var carouselStyle = {
        transform: carouselTransformStyle,
        WebkitTransform: carouselTransformStyle,
        msTransform: carouselTransformStyle,
        MozTransform: carouselTransformStyle
      };
      var elemToShow = this.state.rotationCount % this.props.elements.length;
      var elemToShowBefore = elemToShow - 1 < 0 ? this.props.elements.length - 1 : elemToShow - 1;
      var elemToShowAfter = elemToShow + 1 >= this.props.elements.length ? 0 : elemToShow + 1;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "vertical-carousel-container",
        style: {
          height: this.props.height
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "vertical-carousel",
        style: carouselStyle
      }, this.props.elements.map(function (element, index) {
        var display = 'none';
        var rotation = 0;
        if (index === elemToShow) {
          rotation = carouselRotation * -1;
          display = 'block';
        } else if (index === elemToShowBefore) {
          rotation = carouselRotation * -1 + rotationDistribution;
          display = 'block';
        } else if (index === elemToShowAfter) {
          rotation = carouselRotation * -1 - rotationDistribution;
          display = 'block';
        }
        var transformStyle = "rotateX(".concat(rotation, "deg) translateZ(").concat(figureTranslation, ")");
        var style = {
          transform: transformStyle,
          WebkitTransform: transformStyle,
          msTransform: transformStyle,
          MozTransform: transformStyle,
          height: _this2.props.height,
          display: display
        };
        /* eslint-disable react/no-array-index-key */
        return /*#__PURE__*/_react.default.createElement("figure", {
          key: index,
          style: style
        }, element);
        /* eslint-enable react/no-array-index-key */
      })));
    }
  }]);
  return VerticalCarousel;
}(_react.default.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
VerticalCarousel.propTypes = {
  elements: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  cycleRate: _propTypes.default.number,
  height: _propTypes.default.number.isRequired
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
VerticalCarousel.defaultProps = {
  cycleRate: 2000
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
VerticalCarousel.displayName = 'VerticalCarousel';
var _default = VerticalCarousel;
exports.default = _default;